<crowdctrl-unauthenticated-page [pageTitle]="pageTitle" [showFooter]="false" defaultHref="/login">
  <div class="about-project">
    <crowdctrl-unauth-page-intro>
      <h1 crowdctrlUnauthIntroTitle>Terms</h1>
      <p crowdctrlUnauthIntroLead>
        These terms govern access to and use of {{ appName }} websites and applications.
      </p>
    </crowdctrl-unauth-page-intro>

    <section class="about-project__section" aria-labelledby="terms-acceptance">
      <h2 id="terms-acceptance" class="about-project__heading">Acceptance</h2>
      <p class="about-project__text">
        By accessing or using {{ appName }}, you agree to these terms and to applicable law. If you
        do not accept these terms, you must not use the service.
      </p>
    </section>

    <section class="about-project__section" aria-labelledby="terms-use">
      <h2 id="terms-use" class="about-project__heading">Permitted use</h2>
      <ul class="about-project__list">
        <li>Use the service only for lawful and authorised purposes.</li>
        <li>
          Do not attempt to bypass security controls, access restrictions, or tenancy boundaries.
        </li>
        <li>Do not interfere with service operation or with other users' access.</li>
      </ul>
    </section>

    <section class="about-project__section" aria-labelledby="terms-accounts">
      <h2 id="terms-accounts" class="about-project__heading">Accounts and access</h2>
      <p class="about-project__text">
        You are responsible for activity that occurs under your account credentials. Access may be
        suspended or revoked for policy violations, security concerns, or tenancy administration
        requirements.
      </p>
    </section>

    <section class="about-project__section" aria-labelledby="terms-availability">
      <h2 id="terms-availability" class="about-project__heading">Availability and changes</h2>
      <p class="about-project__text">
        We may modify, suspend, or discontinue features to support reliability, security, and
        operational requirements. Planned and unplanned maintenance may affect availability.
      </p>
    </section>

    <section class="about-project__section" aria-labelledby="terms-warranty">
      <h2 id="terms-warranty" class="about-project__heading">Warranty disclaimer</h2>
      <p class="about-project__text">
        The service is provided on an "as is" and "as available" basis. No warranty is given that
        the service will be uninterrupted, error free, or suitable for every use case.
      </p>
    </section>

    <section class="about-project__section" aria-labelledby="terms-liability">
      <h2 id="terms-liability" class="about-project__heading">Limitation of liability</h2>
      <p class="about-project__text">
        To the extent permitted by law, liability for indirect, incidental, special, consequential,
        or punitive loss is excluded.
      </p>
    </section>

    <section class="about-project__section" aria-labelledby="terms-contact">
      <h2 id="terms-contact" class="about-project__heading">Questions</h2>
      <p class="about-project__text">
        If you have questions about these terms, use
        <a
          href="/contact"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/contact')"
          >Contact us</a
        >.
      </p>
    </section>
  </div>
</crowdctrl-unauthenticated-page>
